import React, { FC } from 'react';
import styles from './VimeoIcon.scss';

export const VimeoIcon: FC = () => <div className={styles.vimeoIcon} />;
